/* unplugin-vue-components disabled */import { render } from "./ReportForm.vue?vue&type=template&id=1f726252&scoped=true&ts=true"
import script from "./ReportForm.vue?vue&type=script&lang=ts"
export * from "./ReportForm.vue?vue&type=script&lang=ts"

import "./ReportForm.vue?vue&type=style&index=0&id=1f726252&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f726252"]])

export default __exports__